import { FieldRegistration } from '../fieldRegistry';
import { renderSubtitleField } from './subtitleFieldRenderer';
import { titleFieldConfig } from './titleFieldConfig';

/** Saved, created and copied like the title: plain text, only when changed. */
export const subtitleFieldConfig: FieldRegistration = {
  ...titleFieldConfig,
  renderer: renderSubtitleField
};
